// React Imports
import { ReactElement, useState } from "react";

// Third Party Library Imports
import { Link } from "react-router-dom";
import { ColumnsType } from "antd/es/table";
import { Select, SelectProps } from "antd";
import { useSelector } from "react-redux";

// Local Imports
import CustomTable from "../../../../components/custom-table/custom-table";
import CustomModal from "../../../../components/custom-modal/custom-modal";
import DeleteModal from "../../../../components/delete-modal/delete-modal";
import clsx from "clsx";

type BusinessAccountProps = {
  customerData: any;
};

const BusinessAccount: React.FC<BusinessAccountProps> = ({
  customerData,
}: BusinessAccountProps): ReactElement => {
  const user = useSelector((state: any) => state.user);
  const [openDeleteModal, setOpenDeleteModal] = useState<boolean>(false);

  const columns: ColumnsType<any> = [
    {
      title: "#",
      dataIndex: "id",
      key: "id",
      fixed: "left",
      render: (_, __, index: number) => <span>{index + 1}</span>,
    },
    {
      title: "Owner name",
      dataIndex: "ownerName",
      key: "ownerName",
      width: 145,
      sorter: (a, b) =>
        String(a?.accountInfo[0]?.nameEn).localeCompare(
          String(b?.accountInfo[0]?.nameEn)
        ),
      fixed: "left",
      render: (_, record) =>
        user?.permissions.includes("kyc_tools") ? (
          <Link
            to={`/home/business-account/${record.id}/${record.activeKycId}/details`}
          >
            {record.accountInfo[0]?.nameEn}
          </Link>
        ) : (
          <span>{record.accountInfo[0]?.nameEn}</span>
        ),
    },
    {
      title: "Account type",
      dataIndex: "accountType",
      key: "accountType",
      sorter: (a, b) =>
        String(a?.clientSubType?.description).localeCompare(
          String(b?.clientSubType?.description)
        ),
      render: (_, record) => <span>{record.clientSubType?.description}</span>,
    },
    {
      title: "Account #",
      dataIndex: "accountCode",
      key: "accountCode",
      width: 130,
      sorter: (a, b) => a?.accountCode - b?.accountCode,
      render: (_, record) =>
        record.accountCode && record.branch !== "SA" ? (
          <Link
            to={`/home/business-account/${record.id}/${record.activeKycId}/details`}
            className="underline text-blue-500"
          >
            {`Account#${record.accountCode}`}
          </Link>
        ) : (
          <Link
            to={
              record?.branch === "SA"
                ? `/home/new-kyc/${record.id}/${record.pendingKycId}`
                : `/home/business-account/${record.id}/${record.pendingKycId}/details`
            }
            className="underline  text-[#FFAF00]"
          >
            {record?.accountCode ? `Account#${record.accountCode}` : `New account`}
          </Link>
        ),

    },
    {
      title: "Nationality",
      dataIndex: "nationality",
      key: "nationality",
      sorter: (a, b) => a.nationality - b.nationality,
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status",
      filters: [
        {
          text: "Active",
          value: "Active",
        },
        {
          text: "InActive",
          value: "InActive",
        },
      ],
      onFilter: (value, record) => record.accountStatus?.description === value,
      sorter: (a, b) =>
        String(a?.accountStatus?.description).localeCompare(
          String(b?.accountStatus?.description)
        ),
      render: (_, record) => (
        <span
          className={clsx(
            "rounded-md text-sm w-[80px] flex items-center justify-center h-[35px]",
            record?.accountStatus?.description === "Rejected"
              ? "bg-red-200 text-white"
              : "bg-gray-600 text-green-500"
          )}
        >
          {record?.accountStatus?.description}
        </span>
      ),
    },
    // {
    //   title: "Actions",
    //   key: "actions",
    //   render: () => (
    //     <div className="business-account-actions-select flex items-center w-full">
    //       <Select
    //         allowClear
    //         showSearch
    //         filterOption={(input, option: any) => {
    //           return (option?.value?.toLowerCase() ?? "").includes(
    //             input.toLowerCase()
    //           );
    //         }}
    //         className="w-full"
    //         value={null}
    //         options={options}
    //         placeholder="Select an action"
    //       />
    //     </div>
    //   ),
    // },
  ];

  return (
    <div className="flex flex-col mt-[10px]">
      <CustomTable columns={columns} data={customerData} showPagination={false} />

      <CustomModal
        isVisible={openDeleteModal}
        centered
        width={450}
        onClose={() => {
          setOpenDeleteModal(false);
        }}
        className="delete-modal"
      >
        <DeleteModal
          onCancel={() => setOpenDeleteModal(false)}
          text="Delete business account!"
          subText="Are you sure to delete this account?"
        />
      </CustomModal>
    </div>
  );
};

export default BusinessAccount;
